import React from 'react';
import { Environment, ENVIRONMENT, getEnvironmentName } from 'utils/environment';
import style from './EnvironmentBanner.module.scss';

interface Props {
  isLoggedIn: boolean;
  environmentsAllowedToRenderBanner: ENVIRONMENT[];
}

const currentEnvironment: Environment = getEnvironmentName();

const EnvironmentBanner: React.FC<Props> = ({ isLoggedIn, environmentsAllowedToRenderBanner }) => {
  const isRenderAllowed: boolean =
    isLoggedIn && (environmentsAllowedToRenderBanner as Environment[]).includes(currentEnvironment);

  return <>{isRenderAllowed && <div className={style.envBaner}>{currentEnvironment} Environment</div>}</>;
};

export default EnvironmentBanner;
